module.exports = __webpack_public_path__ + "static/media/sq_anteraja.7f7d6e19.png";